import type { OrderStatus } from "../../shared/types";

const labels: Record<OrderStatus, string> = { draft: "Draft", pattern_ready: "Pattern ready", in_production: "In production", shipped: "Shipped", delivered: "Delivered" };

export function Status({ value }: { value: OrderStatus }) {
  return <span className={`status status--${value}`}><i />{labels[value]}</span>;
}
